import { render, staticRenderFns } from "./navTop.vue?vue&type=template&id=31defdec&scoped=true&"
import script from "./navTop.vue?vue&type=script&lang=js&"
export * from "./navTop.vue?vue&type=script&lang=js&"
import style0 from "./navTop.vue?vue&type=style&index=0&id=31defdec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31defdec",
  null
  
)

export default component.exports